export const sessionUpdatedMock = {
  sessionId: '0f8cf5c0-04a7-49db-8693-567184ed35df',
  sessionType: 'Desktop',
  accessToken: 'SDSA.DFGFD.SGD',
};
